// extracted by mini-css-extract-plugin
export var bottomRightDock = "_4u-0";